import React from 'react';
import { TagIcon } from '@heroicons/react/20/solid';
import { IService } from '../services-types';
import TerritoryFlag from '../../business-markets-module/elements/TerritoryFlag';
import FileDownloadPreview from '../../../../../elements/FileDownloadPreview';
import ExternalLinkView from '../../../../../elements/ExternalLinkView';

interface ServiceDetailViewProps {
  service: IService
}

export default function ServiceDetailsView(props: ServiceDetailViewProps) {

  const { service } = props;

  return (
    <div className="pl-10 py-8 pr-12">
      {
        service.description && (
          <>
            <p className="text-xs text-neutral-700 py-2">
              Description
            </p>
            <p className="font-semibold text-sm text-neutral-800 whitespace-pre-line">
              {service.description}
            </p>
          </>
        )
      }
      {
        service.territories.length > 0 && (
          <div className="mt-6">
            <p className="text-xs text-neutral-700 py-2">
              Territories
            </p>
            <div className="flex flex-row flex-wrap gap-2 mt-1 mb-2">
              {
              service.territories.map((territory) => (
                <div key={territory.territoryName} className="flex flex-row items-center px-3 py-2 border border-neutral-200 rounded-md">
                  <div className="flex flex-row">
                    <TerritoryFlag small territoryName={territory.territoryName} isoAlpha3Code={territory.isoAlpha3Code} />
                    <span className="ml-1.5 font-semibold text-xs">{ territory.territoryName }</span>
                  </div>
                </div>
              ))
            }
            </div>
          </div>
        )
      }
      {
        ((service.fileAttachments && service.fileAttachments.length > 0) || (service.externalLinks && service.externalLinks.length > 0)) && (
          <div className="mt-6 grid grid-cols-2 gap-4">
            {
              service.fileAttachments && service.fileAttachments.map((file) => (
                <FileDownloadPreview
                  key={file.id}
                  file={{
                    ...file,
                    title: file.description,
                  }}
                />
              ))
            }
            {
              service.externalLinks && service.externalLinks.map((link) => (
                <ExternalLinkView key={link.id} link={link.link} description={link.description} />
              ))
            }
          </div>
        )
      }
      {
        service.coreTags.length > 0 && (
          <div className="pt-4">
            <p className="text-xs text-neutral-700 py-2">
              Tags
            </p>
            <div className="pt-1 flex flex-wrap gap-1">
              {
                service.coreTags.map((tag) => (
                  <div key={tag.name} className="text-xs py-1 px-2 rounded-md border border-main-200 bg-main-25 flex flex-row items-center">
                    <TagIcon className="w-3 h-3 text-main-300 mr-1" />
                    {tag.name}
                  </div>
                ))
              }
            </div>
          </div>
        )
      }
    </div>
  );
}
